<template>
    <div>
        <top-navbar></top-navbar>
<div>
 

<div class="mb-5 background_color">
    <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration " to="/admin/overview"> Home </router-link><span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>Customer<span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>CRM Notes<span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/cmmscrm/index">Manage CRM Notes </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Create CRM Notes  </h6>
    <div  style=" padding-bottom: 200px;" class="container-fluid">
<div class="card bdr-rad2 mt-1 shadow p-2 ">
<div  class="card-body">
  <form @submit.prevent="SaveCrm()" >

    <div class="row">


<div class="col-md-3">
  <div class="form-group required">
          <label class="custom-label" style="font-size: small;">Accets</label>
          <v-select class="font-size_def" label="label"  @input="loadcontact"  v-model="customer.idcustomer"  :options="mcustomers" ></v-select>
       
  </div>
</div>



<div class="col-md-3">
  <div class="form-group required">
          <label class="custom-label" style="font-size: small;">Customer Contact</label>
          <v-select class="font-size_def" label="label"   :options="contacts" v-model="customer.contact_id"
          ></v-select>
        
  </div>
</div>
</div>


<br>
<div style="margin-bottom: 0px;" class="card custom_bdr_rds">
            <div class="card-body custom_bdr_rds">
                <h6 class="purchitem mb-2"><b>Add CRM Notes</b></h6>

                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Comments </label>
                            <textarea rows="3" v-model="crm.comments"  style="font-size: small;" class="form-control" ></textarea>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Job Type</label>
                            <select class="form-select" v-model="crm.job_type">
                              <option  selected>Select....</option>
                              <option >Repair Job</option>
                              <option  >Preventive Job</option>
                            </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Follow up Date</label>
                            <input v-model="crm.followup_date" type="date"  style="font-size: small;" class="form-control" >
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Follow up By</label>
                            <input v-model="username"  style="font-size: small;" class="form-control" disabled>
                    </div>
                  </div>


                </div>

                <div class="row">
                        <div class="col-md-3">
                          <div class="form-group ">
                                  <label class="custom-label " style="font-size: small;">Files</label>
                                   <input type="file" style="font-size: small;"  @change="handleFileUpload"  class="form-control bdr-rad" />
                          </div>
                        </div>

                  </div>
           
                

            </div>
        </div>
   
   <div style="border-bottom: 0px; padding-top: 0px; " class="navbar ">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Create</button>
    </div>
    </div>


</form>
</div>
</div>
</div>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'
  import vSelect from 'vue-select'

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        username:authService.isUsername(),
      
        customer:{},
        aprts:[],
        mcustomers:[],
        contacts:[],
        crms:[],
        crm:{},
        create_crm:{},
        customer_contacts:[],
        user1s:[],
        isButtonDisabled: false
      
      


        
      }

    },
    mounted(){
 
      this.loadApt();
    },
methods : {
          handleFileUpload(event) {
      this.file = event.target.files[0];
    },

  loadView(id){
    this.$router.push('/cmmscrm/view?id='+id);
  },

  async loadApt() {
    try {
         const { data} = await  axios.get('/ciinventory/customerload',{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.mcustomers = data.customers;
           this.contacts = data.contacts;
          // this.mbrands = data.mbrands;
          // this.mproducts = data.mproducts;
         
       } catch (error) {
         console.log(error.response);
       }
  },

  async loadcontact() {
       
     
       try {
         const { data} = await  axios.post('/ciinventory/loadcontact',{idcustomer:this.customer.idcustomer},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.contacts = data.contacts;
          // this.sales = data.salespeoples;
          
         
       } catch (error) {
         console.log(error.response);
       }
     },


  async SaveCrm2() {
    
    this.isButtonDisabled = true;
    
    try {
      const { data} = await  axios.post('/ciinventory/crmcreateall',{userid:this.userid,crm:this.crm,customer:this.customer},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
      this.status = data.status;
       if(this.status == 200){
        this.isButtonDisabled = false;
        this.$router.push('/cmmscrm/index');
       }
      
    } catch (error) {
      console.log(error.response);
    }
  },


      async SaveCrm() {
  if (!this.file) {
    alert("Please select an Excel file first.");
    return;
  }

  const formData = new FormData();
  formData.append("excel_file", this.file);
  formData.append("crm", JSON.stringify(this.crm));
  formData.append("customer", JSON.stringify(this.customer));
  formData.append("userid", JSON.stringify(this.userid));


  try {
    const response = await axios.post(
      "/ciinventory/crmcreateall",
      formData,
      {
        headers: {
          Authorization: "Bearer " + this.access_token,
        "Content-Type": "multipart/form-data",
        //'Content-type': 'application/json',
        },
      }
    );

    const data = response;
      console.log(data);
    if (data.status == 200) {
      alert("Product data uploaded successfully!");
        this.isButtonDisabled = false;
        this.$router.push('/cmmscrm/index');
     // window.location.reload();
      
    } else {
      console.error("Upload failed:", data.message || data);
      alert("Upload failed. Please check the file format or server logs.");
    }
  } catch (error) {
    console.error("Upload error:", error.response || error);
    alert("An error occurred while uploading the file.");
  }
},

      
    



  
  async loadData(id) {
    console.log(this.access_token);
    try {
      const { data} = await  axios.get('/mservicelog/loaddetail?id='+id,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.customer = data.customer;
       this.crms = data.crm;
       this.customer_contacts = data.customer_contact;
       this.user1s = data.user1;
      
    } catch (error) {
      console.log(error.response);
    }
  },

  


},

    components :{
        ContentFooter,
        TopNavbar,
        'v-select': vSelect,
    },
  }

</script>
<style >

</style>